import React from 'react';

const LegendPast = () => (
  <div className="line-chart-legend">
    <div className="legend-item past">
      <div className="legend-marker circle" />
      <div className="legend-description">Jahres&shy;wert</div>
    </div>
    <div className="legend-item past">
      <div className="legend-marker line" />
      <div className="legend-description">30-jähriges Mittel</div>
    </div>
  </div>
);

export default LegendPast;
